import { useQuery } from "@apollo/client";

import { MapEditorObservationPanelValidationStatusDocument } from "./queries.generated";

export function useValidationStatus(observationId: string) {
    const { data, loading } = useQuery(MapEditorObservationPanelValidationStatusDocument, {
        variables: { observationId },
    });

    return { loading, status: data?.observationGetValidationStatus };
}
